import { AxiosResponse } from 'axios';
import { HttpResponseList } from 'shell/models/http-response';
import { ReleasedService } from 'shell/models/certificate';
import {
  CertificateResponse,
  CertificateClient,
} from 'front-office/pages/released-services/list/types';
import { DateTime } from 'luxon';
import { ServiceType } from 'shell/constants/service-type';

export const transformCertificateList = (
  httpResponse: AxiosResponse<HttpResponseList<ReleasedService>>
): CertificateResponse => {
  const data = httpResponse.data.payload?.list || [];

  const count: number = httpResponse.data.payload?.pageInfo?.totalCount || 0;

  const list: Array<CertificateClient> = data.map((item: ReleasedService) => {
    // la somma di vari importi
    const price =
      parseFloat(String(item.importoBollo)) +
      parseFloat(String(item.importoDirittiFissi)) +
      parseFloat(String(item.importoDirittiSegreteria)) +
      parseFloat(String(item.importoDirittiStatoCivile)) +
      parseFloat(String(item.importoSpese));

    // codice servizio
    const typeCode = item.tipo?.toUpperCase() || '';

    // Identificativo
    const serviceNumber =
      typeCode === ServiceType.CartaElettronica || // carta elettronica
      typeCode === ServiceType.CartaCartacea // carta cartacea
        ? item.numeroCartaIdentita
        : (item.key.codiceSiglaRegistro || '') +
          (item.key.idAnnoDocumento || '') +
          (item.key.progressivoDocumento || '');

    return {
      serviceNumber: serviceNumber || '',
      key: item.key,
      type: item.tipoDocumento?.descrizioneTipoDocumento || '',
      release: item.codiceModalitaRilascio || '',
      price,
      fiscalCode: item.codiceFiscaleIntestatario || '',
      certificateDate: item.timestampRilascio
        ? DateTime.fromISO(item.timestampRilascio).toFormat('dd/MM/yyyy')
        : '',
      certificateTime: item.timestampRilascio
        ? DateTime.fromISO(item.timestampRilascio).toFormat('HH:mm')
        : '',
      paymentType: item.tipoPagamento || '',
      operator: item.nomeOperatoreRilascio || '',
      codeOperator: item.codiceOperatoreUltimoAggiornamento || '',
      releaseOperatorCode: item.codiceOperatoreRilascio || '',
      serviceCode: item.codiceServizioRilascio || '',
      ann: item.codiceStato === '3' || item.codiceStato === '4' ? 'Si' : 'No',
      typeCode,
      item,
    };
  });

  const response: CertificateResponse = {
    count,
    list,
  };

  return response;
};
